// React
import axios from 'axios';

import { BASE_URL, SHIPMENT_SERVICE, SERVICE_VERSION } from './configuration';
import { SHIPMENT_SERVICE_ENDPOINT } from './configuration/shipment-service';

export const SHIPMENT_SERVICE_URL = `${BASE_URL}/${SHIPMENT_SERVICE}/${SERVICE_VERSION}`;

export const createShipment = (payload) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
    try {
      const response = await axios({
        method: 'POST',
        url: SHIPMENT_SERVICE_URL + SHIPMENT_SERVICE_ENDPOINT.CREATE_SHIPMENT,
        data: payload
      });
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      return response.data;
    } catch (error) {
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      dispatch({
        type: 'ERROR',
        error: error.response?.data || error.response
      });
    }
  };
};

export const getReadyToShipComments = (orderId) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
    try {
      const response = await axios({
        method: 'get',
        url: `${SHIPMENT_SERVICE_URL}${SHIPMENT_SERVICE_ENDPOINT.COMMENTS}/${orderId}`
      });
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      return response.data;
    } catch (error) {
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      dispatch({
        type: 'ERROR',
        error: error.response?.data || error.response
      });
    }
  };
};

export const getShipmentStatus = (orderId) => {
  return async (dispatch) => {
    dispatch({
      type: 'SET_LOADER',
      payload: true
    });
    try {
      const response = await axios({
        method: 'get',
        url: `${SHIPMENT_SERVICE_URL}${SHIPMENT_SERVICE_ENDPOINT.SHIPMENT_TRACKING_INFO}/${orderId}`
      });
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      return response.data;
    } catch (error) {
      dispatch({
        type: 'SET_LOADER',
        payload: false
      });
      dispatch({
        type: 'ERROR',
        error: error.response?.data || error.response
      });
    }
  };
};
